<div class="row">
	<div class="col-sm-3" *ngIf="application?.Co_Appl_Required === 'Yes'; else elseCoAppRequired">
		<select class="form-select" style="font-weight: bold; font-size: large; width: 100%"
			(change)="switchInterview($event.target.value)" [(ngModel)]="applicationType">
			<option value="" disabled selected>- Select Loan Interview -</option>
			<option value="Primary">Start Primary Loan Interview</option>
			<option value="Co-Applicant">Start Co-Applicant Loan Interview</option>
		</select>
	</div>
	<ng-template #elseCoAppRequired>
		<div class="col-sm-3">
			<select class="form-select" style="font-weight: bold; font-size: large; width: 100%"
				(change)="switchInterview($event.target.value)" [(ngModel)]="applicationType">
				<option value="" disabled selected>- Select Loan Interview -</option>
				<option value="Primary">Start Primary Loan Interview</option>
			</select>
		</div>
	</ng-template>
</div>
<div class="row row-cols-12" *ngIf="this.applicationType">
	<span class="spinner-border" id="loading" *ngIf="spinner === true"></span>
	<div class="row" style="justify-content: right;">
		<div class="sticky">
			<div class="col-sm-10" style="float: right;">
				<div *ngIf="counter; else elseBlock" class="timer-counter-label">
					{{ display_time }}
				</div>
				<ng-template #elseBlock>
					<div class="timer-counter-label">00:00:00</div>
				</ng-template>
			</div>
		</div>
	</div>
	<div style="margin-top: 1em;">
		<mat-card appearance = "outlined">
			<mat-card-content>
				<form [formGroup]="underwritingExForm">
					<p>
						<strong>(If applicant was transferred over for interview)</strong><br>
						Thank you for holding. My name is <strong>{{ currentUser?.full_name }}</strong>. I am one of the Underwriters here
						at LM Credit and will be conducting your loan interview. I am just waiting for TransUnion to release your credit report to me. Is it ok if I put you on a one-minute hold?
					</p>
					<p>
						<strong>(If UW does outbound call to applicant)</strong><br />
						Hello, may I please speak with <strong>{{ Deal_Name }}</strong>? My name is <strong>{{ currentUser?.full_name}}</strong> 
						I am one of the Underwriters here at LM Credit, how are you doing today? I am calling because you are ready to have a loan interview completed and should take
						about 10 to 15 mins. is now a good time?
					</p>
					<p>
						Before we start, please note all calls are recorded for quality assurance and training purposes, and to protect your privacy, can you please confirm your Date of Birth and full address?
					</p>
					<p>
						DOB: 
						<input type="date" class="form-control d-inline-block w-auto" formControlName="dob" *ngIf="application && isLoaded; else loadLoanInterview"/>
					</p>
					<p class="sentence-flow">
						Unit:
						<input type="text" class="form-control d-inline-block w-auto" formControlName="unit" *ngIf="application && isLoaded; else loadLoanInterview"/>
						Address:
						<input type="text" class="form-control d-inline-block w-auto" formControlName="address" *ngIf="application && isLoaded; else loadLoanInterview"/>
						City:
						<input type="text" class="form-control d-inline-block w-auto" formControlName="city" *ngIf="application && isLoaded; else loadLoanInterview"/>
						Province:
						<select class="form-select" style="display: inline-block; min-width: 120px; width: auto;" formControlName="province"
						*ngIf="application && isLoaded; else loadLoanInterview">
							<option *ngFor="let i of provinceList" [Value]="i.refValue">
								{{ i.picklistValue }}
							</option>
						</select>
						Postal Code:
						<input type="text" class="form-control d-inline-block w-auto" formControlName="postalCode" *ngIf="application && isLoaded; else loadLoanInterview"/>
					</p>
					<p class="sentence-flow">Is this address on a native reserve? 
						<select class="form-select" style="display: inline-block; min-width: 90px; width: auto;" formControlName="native_reserve"
						*ngIf="application && isLoaded; else loadLoanInterview">
							<option value="Yes">Yes</option>
							<option value="No">No</option>
						</select>
					</p>
					<p>
						Just to confirm, are you a Canadian citizen, permanent resident or on a work permit?
						<select placeholder="" class="form-select" style="display: inline-block; min-width: 80px; width: auto;"  formControlName="residency_status"
						*ngIf="application && isLoaded; else loadLoanInterview">
							<option *ngFor="let resident of residencies" [value]="resident">{{resident}}</option>
						</select>
					</p>
					<div *ngIf="applicationType === 'Primary'">
						<p class="sentence-flow">
							You have been referred over to us from 
							<ng-select formControlName="agencies" class="inline-field" *ngIf="application && isLoaded; else loadLoanInterview">
								<ng-option *ngFor="let i of agencyName" [value]="i.id">{{i.Account_Name}}</ng-option>
							</ng-select>
							regarding a 
							<ng-select formControlName="creditt" class="inline-field" *ngIf="application && isLoaded; else loadLoanInterview">
								<ng-option *ngFor="let i of creditorName" [value]="i.display_value">{{ i.display_value }}
								</ng-option>
							</ng-select>
							matter and they are asking for 
							<input type="number" class="input-control" formControlName="accountBalance" *ngIf="application && isLoaded; else loadLoanInterview"/>
							is that correct?
						</p>
						<div *ngIf = "isDuplicateLoan?.length > 0">
							<p style="font-weight: bold;">Verify existing LM Credit loan:</p>
							<mat-card-content class="scrollable-card-content">
								<table mat-table [dataSource]="isDuplicateLoan" class="flat-table mat-elevation-z0">
									<ng-container matColumnDef="loanNumber">
										<th mat-header-cell *matHeaderCellDef> Loan Number </th>
										<td *matCellDef="let element" (click)="openLoanMeta($safeNavigationMigration(element?.loan_number))" style="font-weight: bold; color: #1976d2; cursor: pointer;"> 
											<span *ngIf="application && isLoaded; else loadLoanInterview">{{ element?.loan_number }}</span> 
										</td>
									</ng-container>
									<ng-container matColumnDef="name">
										<th mat-header-cell *matHeaderCellDef> Name </th>
										<td mat-cell *matCellDef="let element" style="text-align: justify;">
											<span *ngIf="application && isLoaded; else loadLoanInterview">{{ element?.shortname }}</span>
										</td>
									</ng-container>
									<ng-container matColumnDef="dob">
										<th mat-header-cell *matHeaderCellDef> DOB </th>
										<td mat-cell *matCellDef="let element" style="text-align: justify;">
											<span *ngIf="application && isLoaded; else loadLoanInterview">{{ element?.dob }}</span>
										</td>
									</ng-container>
									<ng-container matColumnDef="email">
										<th mat-header-cell *matHeaderCellDef> Email </th>
										<td mat-cell *matCellDef="let element" style="text-align: justify;">
											<span *ngIf="application && isLoaded; else loadLoanInterview">{{ element?.email }}</span>
										</td>
									</ng-container>
									<ng-container matColumnDef="postalcode">
										<th mat-header-cell *matHeaderCellDef> PostalCode </th>
										<td mat-cell *matCellDef="let element" style="text-align: justify;">
											<span *ngIf="application && isLoaded; else loadLoanInterview">{{ element?.postalcode }}</span>
										</td>
									</ng-container>
									<ng-container matColumnDef="phone">
										<th mat-header-cell *matHeaderCellDef> Phone </th>
										<td mat-cell *matCellDef="let element" style="text-align: justify;">
											<span *ngIf="application && isLoaded; else loadLoanInterview">{{ element?.phone }}</span>
										</td>
									</ng-container>
									<ng-container matColumnDef="address">
										<th mat-header-cell *matHeaderCellDef> Address </th>
										<td mat-cell *matCellDef="let element" style="text-align: justify;">
											<span *ngIf="application && isLoaded; else loadLoanInterview">{{ element?.address }}</span>
										</td>
									</ng-container>
									<ng-container matColumnDef="province">
										<th mat-header-cell *matHeaderCellDef> Province </th>
										<td mat-cell *matCellDef="let element" style="text-align: justify;">
											<span *ngIf="application && isLoaded; else loadLoanInterview">{{ element?.province }}</span>
										</td>
									</ng-container>
									<tr mat-header-row *matHeaderRowDef="loanDupCols;"></tr>
									<tr mat-row *matRowDef="let row; columns: loanDupCols;"></tr>
								</table>
							</mat-card-content>
						</div>
						<p>--- Thank you ---</p>
						<p class="sentence-flow">
							1. You are currently working
							<select formControlName="jobStatus" class="form-select" style="display: inline-block; min-width: 150px; width: auto;"
							*ngIf="application && isLoaded; else loadLoanInterview">
								<option *ngFor="let i of primaryEmpStatus" [value]="i.display_value">
									{{ i.display_value }}
								</option>
							</select>
							at
							<input type="text" class="form-control d-inline-block w-auto" formControlName="company" *ngIf="application && isLoaded; else loadLoanInterview"/>
							as a
							<input type="text" class="form-control d-inline-block w-auto" formControlName="position" *ngIf="application && isLoaded; else loadLoanInterview"/>
							for
							<input type="text" class="form-control d-inline-block w-auto" formControlName="empLength" *ngIf="application && isLoaded; else loadLoanInterview"/>
							and get paid
							<input type="text" class="form-control d-inline-block w-auto me-2" formControlName="salary" *ngIf="application && isLoaded; else loadLoanInterview"/>					
							<select formControlName="frequency" class="form-select" style="display: inline-block; min-width: 150px; width: auto;"
							*ngIf="application && isLoaded; else loadLoanInterview">
								<option *ngFor="let i of primaryPayFrequency" [value]="i.display_value">
									{{ i.display_value }}
								</option>
							</select>
						</p>
						<p class="sentence-flow" style="margin-left: 1.2em;">
							Industry: 
							<ng-select formControlName="industry" class="inline-field" *ngIf="application && isLoaded; else loadLoanInterview">
								<ng-option *ngFor="let item of primaryIndustry" [value]="item.display_value">
									{{ item.display_value }}</ng-option>
							</ng-select>
							Occupation: 
							<ng-select formControlName="occupation" class="inline-field" *ngIf="application && isLoaded; else loadLoanInterview">
								<ng-option *ngFor="let i of primaryOccupation" [value]="i.display_value">
									{{ i.display_value }}
								</ng-option>
							</ng-select>
						</p>
						<p class="sentence-flow"> 
							2. Are you paid direct deposit or with a cheque?
							<select formControlName="Payment_Method" class="form-select" style="display: inline-block; min-width: 120px; width: auto;"
							*ngIf="application && isLoaded; else loadLoanInterview">
								<option value="Direct deposit">Direct deposit</option>
								<option value="Cheque">Cheque</option>
								<option value="Cash">Cash</option>
							</select>
							Perfect! When was your last pay?
							<input type="date" class="form-control d-inline-block w-auto" formControlName="Last_Pay_Date" *ngIf="application && isLoaded; else loadLoanInterview"/>
							When do you get paid next?
							<input type="date" class="form-control d-inline-block w-auto" formControlName="Next_Pay_Date" *ngIf="application && isLoaded; else loadLoanInterview"/>
						</p>					
					</div>
					<div *ngIf="applicationType === 'Co-Applicant'">
						<p>--- Thank you ---</p>
						<p class="sentence-flow">
							1. You are currently working
							<select formControlName="jobStatus" class="form-select" style="display: inline-block; min-width: 120px; width: auto;"
							*ngIf="application && isLoaded; else loadLoanInterview">
								<option *ngFor="let i of coAppEmpStatus" [value]="i.display_value">
									{{ i.display_value }}
								</option>
							</select>
							at
							<input type="text" class="form-control d-inline-block w-auto" formControlName="company" *ngIf="application && isLoaded; else loadLoanInterview"/>
							as a
							<input type="text" class="form-control d-inline-block w-auto" formControlName="position" *ngIf="application && isLoaded; else loadLoanInterview"/>
							for
							<input type="text" class="form-control d-inline-block w-auto" formControlName="empLength" *ngIf="application && isLoaded; else loadLoanInterview"/>
							and get paid
							<input type="text" class="form-control d-inline-block w-auto me-2" formControlName="salary" *ngIf="application && isLoaded; else loadLoanInterview"/>
							<select class="form-select" style="display: inline-block; min-width: 120px; width: auto;" formControlName="frequency"
							*ngIf="application && isLoaded; else loadLoanInterview">
								<option *ngFor="let item of this.lookUps.pay_frequency" [value]="item.display_value">
									{{ item.display_value }}
								</option>
							</select>
						</p>
						<p class="sentence-flow" style="margin-left: 1.2em;">
							Industry: 
							<ng-select formControlName="industry" class="inline-field" *ngIf="application && isLoaded; else loadLoanInterview">
								<ng-option *ngFor="let i of coAppIndustry" [value]="i.display_value">
									{{ i.display_value }}</ng-option>
							</ng-select>
							Occupation: 
							<ng-select formControlName="occupation" class="inline-field" *ngIf="application && isLoaded; else loadLoanInterview">
								<ng-option *ngFor="let i of coAppOccupation" [value]="i.display_value">
									{{ i.display_value }}</ng-option>
							</ng-select>
						</p>
					</div>
					<p class="sentence-flow">
						Is this a staffing agency? 
						<select class="form-select" style="display: inline-block; min-width: 90px; width: auto;" formControlName="staffing_agency"
						*ngIf="application && isLoaded; else loadLoanInterview">
							<option value="Yes">Yes</option>
							<option value="No">No</option>
						</select>
					</p>
					<p class="sentence-flow">
						Are you currently in a consumer proposal, credit counseling or an active bankruptcy? Or in the process of filling for any of those?
						<select class="form-select" style="display: inline-block; min-width: 150px; max-width: 250px;" formControlName="insolvency_status"
						*ngIf="application && isLoaded; else loadLoanInterview">
							<option *ngFor="let insolvency of insolvencyList" [value]="insolvency">{{insolvency}}</option>
							<!-- <option value="Consumer Proposal">Consumer Proposal</option>
							<option value="Bankruptcy">Bankruptcy</option>
							<option value="In process">In process</option> -->
						</select>
					</p>
					<p class="sentence-flow">
						Do you have any active judgements against you? 
						<select class="form-select" style="display: inline-block; min-width: 90px; width: auto;" formControlName="active_judgements"
						*ngIf="application && isLoaded; else loadLoanInterview">
							<option value="Yes">Yes</option>
							<option value="No">No</option>
						</select>
					</p>
					<p class="sentence-flow">
						3. Do you have any active payday loans?
						<select class="form-select d-inline-block w-auto align-middle" style="min-width: 90px; width: auto;" formControlName="Review_any_payday_loan_usage"
							(change)="handleReset($event.target.value, 'underwritingExForm', 'Payday_Loans_Comments')" *ngIf="application && isLoaded; else loadLoanInterview">
							<option value="Yes">Yes</option>
							<option value="No">No</option>
						</select>
						<textarea *ngIf="underwritingExForm.get('Review_any_payday_loan_usage').value ==='Yes'" class="form-control d-inline-block w-auto align-middle" 
						rows="1" style="min-width: 500px; margin-left: 1em;" placeholder="Payday comments..." formControlName="Payday_Loans_Comments"></textarea>
					</p>
					<p class="sentence-flow">
						4. Do you have an overdraft limit?	
						<select class="form-select d-inline-block w-auto align-middle" style="min-width: 90px; width: auto;" formControlName="Overdraft_Limit_Question"
							(change)="handleReset($event.target.value, 'underwritingExForm', 'Overdraft_Limit')" *ngIf="application && isLoaded; else loadLoanInterview">
							<option value="Yes">Yes</option>
							<option value="No">No</option>
						</select>
						<input *ngIf="underwritingExForm.get('Overdraft_Limit_Question').value === 'Yes'" class="form-control d-inline-block w-auto align-middle" 
						style="min-width: 200px; margin-left: 1em;" type="number" placeholder="Amount..." formControlName="Overdraft_Limit" />
					</p>
					<p class="sentence-flow">
						5. Is your bank account joint with anyone else?
						<select class="form-select d-inline-block w-auto align-middle" style="min-width: 90px; width: auto;" formControlName="Yes_No_Is_this_a_joint_Account"
						(change)="handleReset($event.target.value, 'underwritingExForm', 'Is_this_a_joint_Account')" *ngIf="application && isLoaded; else loadLoanInterview">
							<option value="Yes">Yes</option>
							<option value="No">No</option>
						</select>
						<br>
						<span *ngIf="underwritingExForm.get('Yes_No_Is_this_a_joint_Account').value === 'Yes'" style="margin-left: 1em; font-style: italic;">
							(if yes, ask if the other person joint has payroll that gets deposit in that account)
						</span>
						<input *ngIf="underwritingExForm.get('Yes_No_Is_this_a_joint_Account').value === 'Yes'" 
						class="form-control d-inline-block w-auto align-middle" style="min-width: 500px; margin-left: 1em;" type="text"
						placeholder="Payroll info..." formControlName="Is_this_a_joint_Account" />
					</p>
					<p class="sentence-flow">
						6. Other Bank Account
						<select class="form-select d-inline-block w-auto align-middle" style="min-width: 90px; width: auto;" formControlName="Other_Bank_Account"
						*ngIf="application && isLoaded; else loadLoanInterview">
							<option value="Yes">Yes</option>
							<option value="No">No</option>
						</select>
					</p>					
					<p class="sentence-flow">
						7. Are you up to date with your taxes?
						<select class="form-select d-inline-block w-auto align-middle" style="min-width: 150px; width: auto;" formControlName="When_was_the_last_time_you_filed_taxes"
						*ngIf="application && isLoaded; else loadLoanInterview">
							<option value="Up to Date">Up to Date</option>
							<option value="Behind">Behind</option>
							<option value="Never">Never</option>
						</select>
					</p>					
					<p class="sentence-flow">
						8. Do you currently have anything owing to the CRA? <span style="font-style: italic;">(If so how much?)</span>
						<input class="form-control d-inline-block w-auto align-middle" style="min-width: 200px; margin-left: 1em;" placeholder="Amount..." type="number" 
						formControlName="How_much_do_you_owe_Revenue_Canada" *ngIf="application && isLoaded; else loadLoanInterview"/>	
					</p>
					<p class="sentence-flow">
						9. Have you setup an arrangement with the CRA?
						<select class="form-select d-inline-block w-auto align-middle" style="min-width: 90px; width: auto;" formControlName="Have_you_setup_an_arrangement_with_the_CRA"
						*ngIf="application && isLoaded; else loadLoanInterview">
							<option value="Yes">Yes</option>
							<option value="No">No</option>
						</select>	
					</p>
					<p class="sentence-flow">
						10. And how did you get behind on your collection items?
						<textarea class="form-control d-inline-block w-auto align-middle" style="min-width: 500px; margin-left: 1em;" rows="1" cols="40" onfocus="this.rows=2;" 
						formControlName="Reason_for_falling_behind" *ngIf="application && isLoaded; else loadLoanInterview"></textarea>	
					</p>
					<p class="sentence-flow">
						11. Is anyone helping you with household expenses?
						<select class="form-select d-inline-block w-auto align-middle" style="min-width: 90px; width: auto;" formControlName="Do_you_live_with_anyone_else"
						*ngIf="application && isLoaded; else loadLoanInterview">
							<option value="Yes">Yes</option>
							<option value="No">No</option>
						</select>	
					</p>
					<p class="sentence-flow">
						12. How many dependents do you have?
						<select class="form-select d-inline-block w-auto align-middle" style="min-width: 90px; width: auto;" formControlName="Dependents"
						*ngIf="application && isLoaded; else loadLoanInterview">
							<option value="0">0</option>
							<option value="1">1</option>
							<option value="2">2</option>
							<option value="3">3</option>
							<option value="4">4</option>
							<option value="5">5</option>
							<option value="6">6</option>
							<option value="7">7</option>
							<option value="8">8</option>
							<option value="9">9</option>
							<option value="10">10</option>
							<option value="10+">10+</option>
						</select>						
					</p>
					<p class="sentence-flow">
						13. Do you receive any child tax?
						<select class="form-select d-inline-block w-auto align-middle" style="min-width: 90px; width: auto;" formControlName="child_tax" 
						(change)="handleReset($event.target.value, 'underwritingExForm', 'child_tax_amount')" *ngIf="application && isLoaded; else loadLoanInterview">
							<option value="Yes">Yes</option>
							<option value="No">No</option>
						</select>		
						<input *ngIf="underwritingExForm.get('child_tax').value ==='Yes'" class="form-control d-inline-block w-auto align-middle" 
						style="min-width: 200px; margin-left: 1em;" placeholder="Amount..." type="number" formControlName="child_tax_amount"/>	
					</p>
					<p class="sentence-flow">
						14. Do you receive or pay any child support?
						<select class="form-select d-inline-block w-auto align-middle" style="min-width: 90px; width: auto;" formControlName="child_support" 
						(change)="handleReset($event.target.value, 'underwritingExForm', 'child_support_amount')" *ngIf="application && isLoaded; else loadLoanInterview">
							<option value="Yes">Yes</option>
							<option value="No">No</option>
						</select>	
						<input *ngIf="underwritingExForm.get('child_support').value ==='Yes'" class="form-control d-inline-block w-auto align-middle" 
						style="min-width: 200px; margin-left: 1em;" placeholder="Amount..." type="number"  formControlName="child_support_amount"/>	
					</p>
					<p class="sentence-flow">
						15. Are you a homeowner?
						<select class="form-select d-inline-block w-auto align-middle" style="min-width: 90px; width: auto;" formControlName="are_u_homeowner" (change)="interviewHomeOwner($event)"
						*ngIf="application && isLoaded; else loadLoanInterview">
							<option value="Yes">Yes</option>
							<option value="No">No</option>
						</select>				
						<span *ngIf="underwritingExForm.get('are_u_homeowner').value === 'Yes'">
							<p style="margin-left: 1em; font-style: italic;">(If homeowner, ask if they are up to date with their property taxes.)</p>
							<p class="sentence-flow" style="margin-left: 1em;">								
								i. Do you owe any property tax?
								<input class="form-control d-inline-block w-auto align-middle" style="min-width: 200px;" type="text" formControlName="property_taxes" 
								*ngIf="application && isLoaded; else loadLoanInterview"/>
							</p>
							<p class="sentence-flow" style="margin-left: 1em;">	
								ii. Is there a mortgage on the property?
								<select class="form-select d-inline-block w-auto align-middle" style="min-width: 90px; width: auto;" formControlName="mortgage_property"
								*ngIf="application && isLoaded; else loadLoanInterview">
									<option value="Yes">Yes</option>
									<option value="No">No</option>
								</select>							
							</p>
							<p class="sentence-flow" style="margin-left: 1em;">	
								iii. Who is your mortgage with?
								<input type="text" class="form-control d-inline-block w-auto align-middle" style="min-width: 200px;"
									formControlName="mortgage_with" *ngIf="application && isLoaded; else loadLoanInterview"/>
							</p>							
							<p class="sentence-flow" style="margin-left: 1em;">	
								iv. What is current value of the property?
								<input type="number" class="form-control d-inline-block w-auto align-middle" style="min-width: 200px;"
								formControlName="property_value" *ngIf="application && isLoaded; else loadLoanInterview"/>
							</p>
							<p class="sentence-flow" style="margin-left: 1em;">
								v. What is the balance of your mortgage?
								<input type="number" class="form-control d-inline-block w-auto align-middle" style="min-width: 200px;"
									formControlName="mortgage_balance" *ngIf="application && isLoaded; else loadLoanInterview"/>
							</p>
							<p class="sentence-flow" style="margin-left: 1em;">
								vi. What interest rate on your mortgage?
								<input type="number" class="form-control d-inline-block w-auto align-middle" style="min-width: 200px;"
									formControlName="mortgage_interest" *ngIf="application && isLoaded; else loadLoanInterview"/>
							</p>
						</span>
					</p>
					<p style="font-weight: bold;">---Expenses---</p>
					<p class="sentence-flow">
						1. I am now going to go through your monthly expenses with you:
					</p>
					<div class="table-responsive">
						<form class="form-group" formArrayName="ADDITIONAL_EXPENSES">
							<table class="flat-table mat-elevation-z0">
								<thead>
									<tr>
										<th class="expenseCloseWidth" style="background-color: white;"></th>
										<th scope="col" style="background-color: white;">Type</th>
										<th scope="col" style="background-color: white;">Creditor Name</th>
										<th scope="col" style="background-color: white;">Amount</th>
										<th scope="col" style="background-color: white;">Liability</th>
									</tr>
								</thead>
								<tbody>
									<tr *ngFor="
											let control of underwritingExForm.controls
												.ADDITIONAL_EXPENSES['controls'];
											let i = index
										" [formGroupName]="i">
										<td class="expenseCloseWidth">
											<button class="btn-close" (click)="removeSubformExpenses(i)"
												style="width: 10px; float: left" *ngIf="application && isLoaded; else loadLoanInterview"></button>
										</td>
										<td>
											<select class="form-select" formControlName="Type" style="width: 100%" *ngIf="application && isLoaded; else loadLoanInterview">
												<option *ngFor="let item of questionBanks" [ngValue]="item.expenses_type">
													{{ item.expenses_type }}
												</option>
											</select>
										</td>
										<td>
											<input type="text" class="form-control" formControlName="Name1" style="width: 100%" *ngIf="application && isLoaded; else loadLoanInterview"/>
										</td>
										<td>
											<input type="number" class="form-control" formControlName="Amount"
												(keydown)="addSubformAmountEnter($event)" (change)="addSubformAmount()" style="width: 100%" *ngIf="application && isLoaded; else loadLoanInterview"/>
										</td>
										<td>
											<select class="form-select" formControlName="liabilities" style="width: 100%" *ngIf="application && isLoaded; else loadLoanInterview">
												<option *ngFor="let liability of liabilities"  [value]="liability">
													{{ liability }}
												</option>
											</select>	
										</td>
									</tr>
								</tbody>
							</table>
							<button mat-stroked-button color="primary" (click)="addUnderwitingSubform()" style="margin-top: 10px">
								+ Add Expenses
							</button>
						</form>						
					</div>
					<br>
					<p class="sentence-flow">
						Do you have any other loans or bills that you are responsible for?
						<select class="form-select d-inline-block w-auto align-middle" style="min-width: 90px; max-width: 90px;" formControlName="other_loans_bills"
						(change)="handleReset($event.target.value, 'underwritingExForm', 'other_loans_bills_amount')" *ngIf="application && isLoaded; else loadLoanInterview">
							<option value="Yes">Yes</option>
							<option value="No">No</option>
						</select>	
						<textarea *ngIf="underwritingExForm.get('other_loans_bills').value ==='Yes'" class="form-control d-inline-block w-auto align-middle" 
						rows="1" style="min-width: 500px; margin-left: 1em;" placeholder="Loans or bills..." formControlName="other_loans_bills_amount"></textarea>
					</p>
					<p style="line-height: 1;">
						<label class="summary-expense">Total Income (Monthly)</label>							
						<input class="form-control d-inline-block w-auto align-middle" style="min-width: 200px; margin-left: 1em;" type="number" formControlName="totalMonthSubform"
										(keydown)="enteredTotalMonthSubform($event)"
										(change)="clickedTotalMonthSubform()" *ngIf="application && isLoaded; else loadLoanInterview"/>
						<span *ngIf="displayMonthlyIncome != null && displayMonthlyIncome != ''">{{ displayMonthlyIncome }}</span>
					</p>
					<p style="line-height: 1;">
						<label class="summary-expense">Total Expenses (Monthly) </label>
						<span style="font-weight: bold; margin-left: 1em;" *ngIf="application && isLoaded; else loadLoanInterview">{{ totalSubformAdditional | currency }}</span>
					</p>
					<p  style="line-height: 1;">
						<label class="summary-expense">TDSR</label>
						<span style="font-weight: bold; margin-left: 1em;" *ngIf="application && isLoaded; else loadLoanInterview">{{ tdsr }}%</span>
					</p>
					<p style="line-height: 1;">
						<label class="summary-expense">Loan Payments (Monthly)($)</label>
						<input type="number" class="form-control d-inline-block w-auto align-middle" style="min-width: 200px; margin-left: 1em;" formControlName="currentLoanSubform"
										(keydown)="enteredCurrentLoanSubform($event)"
										(change)="clickedCurrentLoanSubform()" *ngIf="application && isLoaded; else loadLoanInterview"/>	
					</p>
					<div style="display: flex; flex-direction: row; gap: 1em;">
						<p class="sentence-flow">
							Institution Name<br /><input type="text" class="input-control"
							formControlName="Financial_Institution_Name" *ngIf="application && isLoaded; else loadLoanInterview"/>					
						</p>
						<p class="sentence-flow">
							Institution Number<br /><input type="text" class="input-control"
							formControlName="Financial_Institution_Number"
							(keydown)="this.functions.numberOnly($event)" *ngIf="application && isLoaded; else loadLoanInterview"/>
						</p>
						<p class="sentence-flow">
							Bank Account Number<br /><input type="text" class="input-control"
							formControlName="Bank_Account_Number" (keydown)="this.functions.numberOnly($event)" *ngIf="application && isLoaded; else loadLoanInterview"/>
						</p>
						<p class="sentence-flow">
							Branch Transit Number<br /><input type="text" class="input-control"
							formControlName="Bank_Transit_No" (keydown)="this.functions.numberOnly($event)" />
						</p>
						<p class="sentence-flow">
							Branch Address<br /><input type="text" class="input-control"
							formControlName="Branch_Address" *ngIf="application && isLoaded; else loadLoanInterview"/>
						</p>
					</div>
					<p class="sentence-flow">
						2. I am quickly going to check your bank statements and credit report (Check active trades & put amount and CB in the TDS underwriting tab
						drop down ex. Credit cards, car payments, installment loans etc...)
					</p>
					<p class="sentence-flow">
						3. I am now going to go through some of your transactions and locate payroll deposits as well. (Check for insurance payments, payday loans,
						etc... )
					</p>
					<p class="sentence-flow">
						4. Please give me a moment while I get an average of your monthly income (complete the income formula and place that amount in the income
						field in the in underwriting TDS tab)
					</p>
					<p class="sentence-flow">
						5. Do you have any other loans or bills that you are responsible for?
					</p>
					<p>--Final Statments--</p>
					<p class="sentence-flow">
						Thank you <strong>{{ Deal_Name }}</strong>, now that I have all your information I will submit the
						application to the credit bureau department & a representative will call you back with a decision.
						<br /><br />
						Please wait by your phone and someone will be in contact with you
						shortly. Thank you so much for your time, Have a great day!
					</p>
				</form>
				<div id="message" *ngIf="errorMessageLog.length !== 0">
				<div style="padding: 5px">
					<div id="inner-message">
						<p>
							<ngb-alert type="danger" (closed)="clearErrors()">
								{{ errorMessage }}
							</ngb-alert>
						</p>
					</div>
				</div>
			</div>
			<h1 id="saveMessage"></h1>
			<button mat-raised-button color="primary" (click)="saveInterviewScript()" style="width: 150px;" id="saveLoanInterviewButton">
				Save
			</button>
			</mat-card-content>
		</mat-card>			
		<ng-template #loadLoanInterview>
			<ngx-skeleton-loader count="1" appearance="line" 
				[theme]="{ 
				'height': '30px', 
				'width': '150px', 
				'display': 'inline-block', 
				'margin-left': '5px',
				'vertical-align': 'middle',
				'margin-bottom': '0'}" />	
		</ng-template>
	</div>
	
	<div *ngIf="show_notes_stage === true" style="margin-top: 1em; display: grid;  grid-template-columns: 2fr 1fr; gap: 20px; margin-bottom: 4em;">
		<mat-card appearance = "outlined">
			<mat-card-content>
				<form [formGroup]="loanInterviewNote" class="row" style="text-align: left">
					<h6>NOTE - {{ applicationType }} Applicant</h6>
					<div style="display: flex; flex-direction: row; gap: 1em; width: 100%;">
						<mat-form-field appearance="outline" style="width: 100%;">
							<mat-label>Note Subject</mat-label>
							<mat-select formControlName="subject" (selectionChange)="matchSubject($event.value)" panelClass="custom-select-panel" required>
								<mat-option>
									<ngx-mat-select-search 
										formControlName="subjectSearch"
										placeholderLabel="Search subject..."
										noEntriesFoundLabel="No matching results">
									</ngx-mat-select-search>
								</mat-option>
								<mat-option *ngFor="let item of filteredSubjects | async" [value]="item.subject">
									{{ item.subject }}
								</mat-option>
							</mat-select>
							<mat-error *ngIf="loanInterviewNote.controls['subject'].hasError('required') &&loanInterviewNote.controls['subject'].touched" >
								Subject is required
							</mat-error>
						</mat-form-field>
						<mat-form-field appearance="outline" style="width: 100%;" class="visually-hidden">
							<mat-label>Description</mat-label>
							<input matInput  formControlName="description" readonly>
						</mat-form-field>
					</div>
					<div style="display: flex; flex-direction: row; gap: 1em; width: 100%;">
						<mat-form-field appearance="outline" style=" width: 100%;">
							<mat-label>Note</mat-label>
							<textarea matInput placeholder="Notes..." rows="4" formControlName="note" required></textarea>
							<mat-error *ngIf="loanInterviewNote.controls['note'].hasError('required') && loanInterviewNote.controls['note'].touched">
								Note is required
							</mat-error>
						</mat-form-field>
						<div style="width: 150px;">						
							<h1 id="successfulNote"></h1>
							<button mat-raised-button color="primary" id="saveLTNoteButton" (click)="saveLoanInterviewNotes()" style="width: 150px;"
								[disabled]="loanInterviewNote.invalid">
								Save
							</button>
						</div>
					</div>
				</form>
			</mat-card-content>
		</mat-card>
		<mat-card appearance = "outlined">
			<mat-card-content>
				<form [formGroup]="loanInterviewStage" class="row" style="text-align: left">
					<h6>STAGE - Update</h6>
					<div style="display: flex; flex-direction: column; width: 100%;">
						<mat-form-field appearance="outline" style="width: 100%;">
							<mat-label>Stage</mat-label>
							<mat-select formControlName="Stage" (selectionChange)="onStageSelection($event)" required>
								<mat-option>
									<ngx-mat-select-search 
										formControlName="stageSearch"
										placeholderLabel="Search stage..."
										noEntriesFoundLabel="No matching results">
									</ngx-mat-select-search>
								</mat-option>
								<mat-option *ngFor="let item of filteredStages | async" [value]="item.id">
									{{ item.display_value }}
								</mat-option>
							</mat-select>						
							<mat-error *ngIf="loanInterviewStage.controls['Stage'].hasError('required') && loanInterviewStage.controls['Stage'].touched">
								Stage is required
							</mat-error>
						</mat-form-field>
						<div style="width: 150px;">
							<h1 id="successfulStage"></h1>
							<button mat-raised-button color="primary" (click)="saveStageLoanInterview()" id="saveLTStageButton" style="width: 150px;" [disabled]="loanInterviewStage.invalid">
								Save
							</button>
						</div>
					</div>
				</form>
			</mat-card-content>
		</mat-card>	
	</div>